import React from "react";
import "./SubscriptionContactSupportModal.scss";

import { useSelector } from "react-redux";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Modal, {
  ModalText,
  ModalTitle,
  OutsideClickModes,
} from "src/app/components/Modal/Modal";
import { RootState } from "src/redux/reducers";
import { ReactComponent as InfoIcon } from "src/images/info-circle-blue-empty.svg";
import { WorkspacePermissionsEnum } from "src/utils/PermissionsEnums";

interface Props {
  onClose: () => void;
  demandPermission?: boolean;
}

export function SubscriptionContactSupportModal(props: Props) {
  const { onClose, demandPermission } = props;

  const { identity } = useSelector((state: RootState) => state.mainReducer);

  const invitationUrl = identity?.subscriptionData?.calendly_invitation_url;

  const hasPermission = identity?.permissions?.workspace?.includes(
    WorkspacePermissionsEnum.CLOSE_WORKSPACE_EXPIRED_MODAL,
  );

  const handleClose = () => {
    if (hasPermission || !demandPermission) {
      onClose();
    }
  };

  return (
    <Modal
      className="subscription-contact-support-modal"
      overlayClassName="subscription-contact-support-modal__overlay"
      closeButtonText={
        <IDHFormattedMessage id="ws_cancel" defaultMessage="Cancel" />
      }
      displayCancelButton={hasPermission || !demandPermission}
      closeButtonVariant="white-with-light-grey-border"
      onClose={handleClose}
      outsideClick={OutsideClickModes.Allow}
    >
      <ModalTitle>
        <InfoIcon />
        <IDHFormattedMessage
          id="ws_contact_sales"
          defaultMessage="Contact sales"
        />
      </ModalTitle>

      <ModalText>
        <IDHFormattedMessage
          id="ws_to_contact_our_support_team_please_write_to"
          defaultMessage="To contact our support team, please write to"
        />
        :
        <div className="subscription-contact-support-modal__email">
          <a href={invitationUrl || "#"} target="_blank" rel="noreferrer">
            {invitationUrl}
          </a>
        </div>
      </ModalText>
    </Modal>
  );
}
